<p-confirmpopup></p-confirmpopup>
<p-toast [baseZIndex]="20000"></p-toast>
<p-dialog header=" {{ cellValue[0].toUpperCase() }}" [modal]="true" [(visible)]="dialogVisible"
  [style]="{ width: '50rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="true">



</p-dialog>

<div class="filter-dropdown-container-dis">
  <app-dropdown [options]="districtOptions" [(selectedValue)]="selectedDistrict"
    (selectedValueChange)="onDistrictChange($event)" placeholder="District" aria-label="District"
    customClass="districts-district-dropdown" [showLabel]="false" label="District"
  [showFloatingLabel]="true"></app-dropdown>

  <app-dropdown [options]="typeOptions" [(selectedValue)]="selectedType" (selectedValueChange)="onTypeChange($event)"
    placeholder="Type" aria-label="Type" customClass="districts-type-large-dropdown-adjustment" [showLabel]="false"
  label="Type" [showFloatingLabel]="true"></app-dropdown>

  <app-dropdown [options]="dispatchViewOptions" [(selectedValue)]="selectedDispatchView"
    (selectedValueChange)="onDispatchViewChange($event)" placeholder="Dispatch Status" aria-label="Dispatch Status"
    customClass="districts-dispatch-dropdown-adjustment" [showLabel]="false" label="Dispatch Status"
  [showFloatingLabel]="true"></app-dropdown>

  <!-- <span [ngClass]="{'p-float-label': true}">
  <p-datepicker [(ngModel)]="selectedDataTaken" name="selectedDataTaken" class="calender-icon" [showIcon]="true"
  (onSelect)="onDateTakenChange($event)" dateFormat="mm/dd/yy"></p-datepicker>
  <label style="display: block; font-size: 16px; color: #02060e;">
    {{selectDate}}
  </label>
</span> -->

<app-datepicker [(ngModel)]="selectedDataTaken" (onSelectChange)="onDateTakenChange($event)"
[inputlabel]="selectDate"></app-datepicker>

<div class="districts-search-button">
  <button pButton type="button" label="Search" class="search-button" (click)="onSearch()"></button>

  <button pButton type="button" label="Clear" class="clear-button" (click)="onClear()"></button>
</div>
</div>

@if (isLoading) {
  <div class="loading-container">
    <p-progressSpinner>
      <style class="custom-spinner"></style>
    </p-progressSpinner>
    <p>{{ processMessage }}</p>
  </div>
}

<app-table #tblConfig [showCheckRowColumn]="false" [SingleRowSelection]="true" [columns]="lsNorthDataColumns"
  [rows$]="filteredData$" [pageSize]="10" (onAction2ButtonClicked)="onReloadClicked()" [actionButtons]="actionButtons"
  (onCellClicked)="onCellClicked($event)" [totalRecords]="totalRecords" [pageNumber]="pageNumber" [pageSize]="pageSize"
  (pageChanged)="handlePageChange($event)" (sortClicked)="onSortClicked($event)"
(onSearchText)="onSearchText($event)"></app-table>